module.exports = __webpack_public_path__ + "img/B2_HQ02.9bdc968c.jpg";